import { Component } from '@angular/core';
import { AbstractComponent } from '../abstract-component';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-acercade',
  imports: [RouterOutlet,
        RouterLink,
        RouterLinkActive],
  templateUrl: './acercade.component.html',
  styleUrl: './acercade.component.css'
})
export class AcercadeComponent extends AbstractComponent{

  

  ngOnInit(): void {
    console.log('Acerca de component initialized');
  }

  // Additional methods can be added here if needed

}
